// Login/register responses describe the new identity. Never merge a cached
// guest's token, balance or flags into that account.
export function applyAuthenticatedAccount(response, setPersist) {
  const playerInfo = { ...response.player_info, is_guest: false, is_demo: false };
  setPersist("user_info", playerInfo);
  setPersist("abtest_tag", playerInfo.abtest_tag);
  setPersist("gatesvr", response.gatesvr);
  return playerInfo;
}
